module.exports = __webpack_public_path__ + "static/img/taian2.8985fdd1.jpg";